import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { isActive } from '../util';
import { SectionC } from '../../oasis-sections/section-c';
// eslint-disable-next-line
export const sectionCSkipPatterns = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level\
        const payload = input;
        // C-skip pattern-5790
        if (isActive(SectionC.c0200, version, payload.SectionA?.m0100) &&
            isActive(SectionC.c0300, version, payload.SectionA?.m0100) &&
            isActive(SectionC.c0400, version, payload.SectionA?.m0100) &&
            isActive(SectionC.c0500, version, payload.SectionA?.m0100)) {
            const fields = [
                payload.SectionBC?.c0200,
                payload.SectionBC?.c0300?.c0300a,
                payload.SectionBC?.c0300?.c0300b,
                payload.SectionBC?.c0300?.c0300c,
                payload.SectionBC?.c0400?.c0400a,
                payload.SectionBC?.c0400?.c0400b,
                payload.SectionBC?.c0400?.c0400c,
                payload.SectionBC?.c0500,
            ];
            // (b) If C0100=[1], then all active items from C0200 through C0500 must not equal [^].
            if (payload.SectionBC?.c0100 === '1') {
                if (fields.some((field) => field === '')) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: '-5790 (b) If C0100= 1. Yes, then items from C0200 through C0500 must NOT be empty.',
                        path: ['SectionBC', 'c0100'],
                    });
                }
            }
        }
    }
};
// Note: a and c hides items in the UI, thus preventing users from making corrections.
// Setting the proper values should be handled programmatically
// C-skip pattern-5790
// (a) If C0100=[0], then all active items from C0200 through C0500 must equal [^].
// (b) If C0100=[1], then all active items from C0200 through C0500 must not equal [^].
// (c) If C0100=[-], then all active items from C0200 through C0500 must equal [-].
